/* ============================================================
   article-lightbox.js — 記事本文の画像をタップで拡大表示する
   スコープ: .blog-post-content 内の <figure class="figure"> の画像
   読み込み: theme.liquid で template.name == 'article' ガード
             {{ 'article-lightbox.js' | asset_url | script_tag }} 等で読み込む
   対のCSS : article-style.css の「画像ライトボックス」ブロック
   ------------------------------------------------------------
   記事側の追記は不要。.figure の画像を自動で拡大対象にする。
   拡大したくない画像は <img data-nozoom> を付ける。
   ============================================================ */
(function () {
  'use strict';

  var SCOPE = '.blog-post-content';
  var FIG = 'figure.figure';

  var overlay, inner, imgEl, capEl, closeBtn, spinner;
  var lastFocused = null;
  var isOpen = false;
  var reqId = 0; /* 連続で開いたときに、古い読み込み完了で上書きしないための番号 */

  /* 表示用に width を絞ってあるCDN画像は、拡大時に大きい方を取り直す。
     Shopifyは元画像より大きくは返さないので、上限を指定しても安全。 */
  function fullSrc(img) {
    var src = img.getAttribute('data-full') || img.currentSrc || img.src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$11800');
    return src;
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'a97-lb';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', '拡大画像');
    overlay.hidden = true;

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'a97-lb__close';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.innerHTML = '&times;';

    inner = document.createElement('div');
    inner.className = 'a97-lb__inner';

    imgEl = document.createElement('img');
    imgEl.className = 'a97-lb__img';
    imgEl.alt = '';

    capEl = document.createElement('p');
    capEl.className = 'a97-lb__cap';

    spinner = document.createElement('div');
    spinner.className = 'a97-lb__spinner';
    spinner.setAttribute('aria-hidden', 'true');

    inner.appendChild(imgEl);
    inner.appendChild(capEl);
    overlay.appendChild(closeBtn);
    overlay.appendChild(spinner);
    overlay.appendChild(inner);
    document.body.appendChild(overlay);

    /* 背景・余白のクリックで閉じる（画像そのものは閉じない） */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target === inner) close();
    });
    closeBtn.addEventListener('click', close);
  }

  function open(img) {
    if (!overlay) build();
    lastFocused = document.activeElement;

    var myId = ++reqId;
    var small = (img.complete && img.naturalWidth) ? (img.currentSrc || img.src) : '';
    var large = fullSrc(img);

    imgEl.alt = img.getAttribute('alt') || '';

    var fig = img.closest(FIG);
    var cap = fig ? fig.querySelector('figcaption') : null;
    var text = cap ? cap.textContent.replace(/\s+/g, ' ').trim() : '';
    capEl.textContent = text;
    capEl.style.display = text ? '' : 'none';

    overlay.classList.remove('is-blank', 'is-loading');
    if (small) {
      /* 一覧で読み込み済みの画像をまず出す。
         これで「画像より先にキャプションだけが出る」状態にならない。 */
      imgEl.src = small;
      if (large !== small) overlay.classList.add('is-loading');
    } else {
      /* まだ1枚も読めていない場合だけ、画像もキャプションも伏せて待つ */
      imgEl.removeAttribute('src');
      overlay.classList.add('is-blank');
    }

    if (large !== small) {
      var pre = new window.Image();
      pre.onload = function () {
        if (myId !== reqId || !isOpen) return;
        imgEl.src = large;
        overlay.classList.remove('is-blank', 'is-loading');
      };
      pre.onerror = function () {
        if (myId !== reqId || !isOpen) return;
        /* 高解像度が取れないときは、元の画像のまま表示する */
        if (!imgEl.getAttribute('src')) imgEl.src = img.currentSrc || img.src;
        overlay.classList.remove('is-blank', 'is-loading');
      };
      pre.src = large;
    }

    overlay.hidden = false;
    document.documentElement.classList.add('a97-lb-open');
    /* 次フレームでクラスを足してフェードインさせる */
    window.requestAnimationFrame(function () {
      overlay.classList.add('is-open');
    });
    closeBtn.focus();
    isOpen = true;
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('a97-lb-open');

    var finish = function () {
      if (isOpen) return;
      overlay.hidden = true;
      overlay.classList.remove('is-blank', 'is-loading');
      imgEl.removeAttribute('src');
      overlay.removeEventListener('transitionend', finish);
    };
    overlay.addEventListener('transitionend', finish);
    window.setTimeout(finish, 400); /* transitionend が来ない環境の保険 */

    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* --- 拡大対象に印を付ける（カーソル・キーボード操作用） --- */
  function mark(root) {
    var imgs = (root || document).querySelectorAll(SCOPE + ' ' + FIG + ' img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.hasAttribute('data-nozoom')) continue;
      if (img.classList.contains('a97-zoomable')) continue;
      if (img.closest('a')) continue; /* リンク画像は既存の挙動を優先 */
      img.classList.add('a97-zoomable');
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      if (!img.getAttribute('aria-label')) {
        img.setAttribute('aria-label', (img.getAttribute('alt') || '画像') + ' を拡大表示');
      }
    }
  }

  /* --- クリック / タップ --- */
  document.addEventListener('click', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    if (!img.classList.contains('a97-zoomable')) return;
    e.preventDefault();
    open(img);
  });

  /* --- キーボード --- */
  document.addEventListener('keydown', function (e) {
    var k = e.key;
    if (isOpen) {
      if (k === 'Escape' || e.keyCode === 27) {
        close();
      } else if (k === 'Tab' || e.keyCode === 9) {
        /* 開いている間はフォーカスを閉じるボタンに閉じ込める */
        e.preventDefault();
        closeBtn.focus();
      }
      return;
    }
    if (k === 'Enter' || k === ' ' || e.keyCode === 13 || e.keyCode === 32) {
      var el = document.activeElement;
      if (el && el.tagName === 'IMG' && el.classList.contains('a97-zoomable')) {
        e.preventDefault();
        open(el);
      }
    }
  });

  /* --- 起動 ---
     head から defer 無しで読まれた場合、この時点ではまだ <body> が
     存在しない。DOMの準備を待ってから初期化する。 */
  function init() {
    var target = document.querySelector(SCOPE);
    if (!target) return;
    mark();
    /* テーマが記事本文を後から差し替えるケースへの保険 */
    if (window.MutationObserver) {
      new MutationObserver(function () { mark(); })
        .observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();